import { corNoPonto, detectarManchas, identificarMarcadores, type Identificacao, type Imagem } from '@equiview/domain';

/**
 * Deteccao dos marcadores sobre os pixels da foto. Roda no Web Worker
 * (`deteccao.worker.ts`) e, sem ele, na thread principal (`deteccao.ts`).
 */

/** A foto e reduzida antes: um adesivo de 4-5 cm a 4-5 m ainda fica com ~20 px. */
const LADO_MAXIMO = 1600;

export interface ResultadoDaDeteccao extends Identificacao {
  /** Quantas manchas da cor do adesivo foram achadas. */
  manchas: number;
}

export async function pixelsDaFoto(blob: Blob): Promise<Imagem> {
  // Mesma orientacao que o <img> mostra (EXIF do celular), senao os pontos giram.
  const bmp = await createImageBitmap(blob, { imageOrientation: 'from-image' });
  const k = Math.min(1, LADO_MAXIMO / Math.max(bmp.width, bmp.height));
  const w = Math.max(1, Math.round(bmp.width * k));
  const h = Math.max(1, Math.round(bmp.height * k));
  const canvas: OffscreenCanvas | HTMLCanvasElement =
    typeof OffscreenCanvas !== 'undefined' ? new OffscreenCanvas(w, h) : Object.assign(document.createElement('canvas'), { width: w, height: h });
  const ctx = canvas.getContext('2d') as OffscreenCanvasRenderingContext2D | CanvasRenderingContext2D | null;
  if (!ctx) throw new Error('Este aparelho não consegue ler os pixels da foto.');
  ctx.drawImage(bmp, 0, 0, w, h);
  bmp.close();
  return ctx.getImageData(0, 0, w, h);
}

export function processar(img: Imagem, cor: string, marcadores?: readonly string[]): ResultadoDaDeteccao {
  const manchas = detectarManchas(img, { cor });
  return { ...identificarMarcadores(manchas, { proporcao: img.width / img.height, marcadores }), manchas: manchas.length };
}

export { corNoPonto };
